export const ERROR_SOURCES = {
  PRE_INIT: 'pre_init',
  RUNTIME: 'runtime',
  VUE: 'vue',
  PROMISE: 'promise',
  RESOURCE: 'resource',
  UNKNOWN: 'unknown',
};

export const APP_NAME = 'web';
